import {trapFocus, removeTrapFocus} from '../vendor/theme-scripts/theme-a11y';

const selectors = {
  wrapper: '[data-search-popdown-wrap]',
  popdownTrigger: 'data-popdown-toggle',
  close: '[data-close-popdown]',
  input: '[data-predictive-search-input]',
  underlay: '[data-search-underlay]',
};

const classes = {
  underlayVisible: 'underlay--visible',
  isVisible: 'is-visible',
};

let sections = {};

class SearchPopdownTriggers {
  constructor(trigger) {
    this.trigger = trigger;
    this.key = this.trigger.getAttribute(selectors.popdownTrigger);
    this.popdown = document.querySelector(`[id='${this.key}']`);
    this.input = this.popdown.querySelector(selectors.input);
    this.close = this.popdown.querySelector(selectors.close);
    this.wrapper = this.popdown.closest(selectors.wrapper);
    this.underlay = this.wrapper.querySelector(selectors.underlay);

    this.initTriggerEvents();
    this.initPopdownEvents();
  }

  initTriggerEvents() {
    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);
    this.trigger.addEventListener(
      'click',
      function (evt) {
        evt.preventDefault();
        this.showPopdown();
      }.bind(this)
    );
    this.trigger.addEventListener(
      'keyup',
      function (evt) {
        if (evt.code !== 'Space') {
          return;
        }
        this.showPopdown();
      }.bind(this)
    );
  }

  initPopdownEvents() {
    this.popdown.addEventListener(
      'keyup',
      function (evt) {
        if (evt.code !== 'Escape') {
          return;
        }
        this.hidePopdown();
      }.bind(this)
    );
    this.close.addEventListener(
      'click',
      function () {
        this.hidePopdown();
      }.bind(this)
    );
    this.underlay.addEventListener(
      'click',
      function () {
        this.hidePopdown();
      }.bind(this)
    );
  }

  hidePopdown() {
    this.popdown.classList.remove(classes.isVisible);
    this.underlay.classList.remove(classes.underlayVisible);
    this.trigger.focus();
    removeTrapFocus();
    this.popdown.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  }

  showPopdown() {
    this.popdown.classList.add(classes.isVisible);
    this.underlay.classList.add(classes.underlayVisible);
    trapFocus(this.popdown, {elementToFocus: this.input});
    this.popdown.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  }
}

const searchPopdown = {
  onLoad() {
    sections[this.id] = {};
    const trigger = this.container.querySelector(`[${selectors.popdownTrigger}]`);
    if (trigger) {
      sections[this.id] = new SearchPopdownTriggers(trigger);
    }
  },
  onUnload: function () {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
};

export default searchPopdown;
